import { StandardEvents } from '@shopify/events';
// Shared native apparel presentation. Does not write catalog, cart, or supplier data.
(() => {
  const processed = new WeakSet();
  const editorial = new Map([
    [10269638033511, ['Burnt Orange', 46488066359399]],
    [10258409554023, ['Sport Grey', 46423677403239]],
    [10231579344999, ['White', 46255235956839]],
    [10231573872743, ['Red', 46255168323687]],
    [10231562174567, ['Burnt Orange', 46255036104807]],
    [10253573652583, ['Carolina Blue', 46395240382567]],
    [10253573980263, ['White', 46395257421927]],
    [10228663058535, ['Blossom', 46395768471655]],
    [10231559225447, ['Pink', 46254954152039]],
    [10231560142951, ['Pink', 46254984429671]],
    [10253573357671, ['Butter', 46395200667751]],
    [10258405982311, ['Light Blue', 46423442391143]],
    [10258407719015, ['Pink', 46423489970279]],
    [10258407948391, ['Light Blue', 46423506878567]],
    [10258408865895, ['Pink', 46423542136935]],
    [10258432819303, ['White', 46423673831527]],
    [10258477547623, ['Pink', 46423826366567]],
    [10258482102375, ['Light Blue', 46423874732135]],
    [10266530185319, ['Bubble Pink', 46468932272231]],
  ]);
  const base = src => String(src || '').split('?')[0].split('/').pop();
  const key = name => name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const reviewedNeutral = new Set(['46423678386279', '46395278295143', '46395250114663', '46513259249767']);
  let productInteraction = false;
  document.addEventListener('pointerdown', e => {
    if (e.target.closest('main variant-picker, main product-form-component, main media-gallery')) productInteraction = true;
  }, { capture: true, passive: true });
  document.addEventListener('input', e => {
    if (e.target.closest('main product-form-component, main variant-picker')) productInteraction = true;
  }, { capture: true, passive: true });

  function mediaFor(data, color) {
    return data.media.find(m => String(m.id) === String(color.media));
  }
  function imageSource(src, width = 900) {
    const url = new URL(src, location.origin);
    url.searchParams.set('width', String(width));
    return url.href;
  }
  async function resolve(data) {
    let reviewed = {};
    if (data.reviewedMediaMap) {
      const response = await fetch(data.reviewedMediaMap);
      if (!response.ok) throw Error('Reviewed apparel media map unavailable');
      reviewed = await response.json();
      for (const color of data.colors) {
        const match = data.media.find(m => reviewed[m.id] && key(reviewed[m.id]) === key(color.name) && reviewed.__views?.[m.id] === 0);
        if (match) { color.media = match.id; color.image = imageSource(match.src, 160); }
      }
    }
    if (data.id === 10258432819303) {
      const youthMedia = { White: 46423673831527, Navy: 46423675994215, Black: 46423675011175 };
      for (const color of data.colors) {
        const media = data.media.find(m => m.id === youthMedia[color.name]);
        if (media) { color.media = media.id; color.image = imageSource(media.src, 160); }
      }
    }
    const ranked = await Promise.all(data.colors.map(async (color, index) => ({
      ...color, index, score: await window.LaurelColorOrder.score({ dataset: {
        colorRgb: color.rgb || '', colorImage: color.image || '',
      } }),
    })));
    if (ranked.some(color => color.score == null)) throw Error('Missing native color evidence');
    const anchor = color => color.name.toLowerCase() === 'white' ? -1 : color.name.toLowerCase() === 'black' ? 1 : 0;
    ranked.sort((a, b) => anchor(a) - anchor(b) || b.score - a.score || a.index - b.index);
    return { ranked, reviewed };
  }

  function updateCard(node, data, ranked) {
    const card = node.closest('product-card, .resource-card__wrapper, .suggested-product-card, .boutique-featured article');
    if (!card || card.querySelector('[data-page-image-override]') || card.matches(':focus-within') || card.dataset.apparelCustomerSelection) return;
    // Card defaults always follow Shopify's current main image, independently
    // of availability/color ordering. Product-page and explicit picker paths stay native.
    data = { ...data, useFeaturedDefault: true,
      featuredVariant: ranked.find(c => String(c.media) === String(data.featuredMedia))?.variant || null };
    let color = ranked.find(c => c.available);
    const choice = data.useFeaturedDefault ? null : editorial.get(data.id);
    if (data.useFeaturedDefault) color = ranked.find(c => String(c.variant) === String(data.featuredVariant)) || ranked.find(c => String(c.media) === String(data.featuredMedia));
    if (choice) color = ranked.find(c => c.name === choice[0] && c.available) || color;
    if (!color && !data.useFeaturedDefault) return;
    const media = data.useFeaturedDefault ? data.media.find(m => String(m.id) === String(data.featuredMedia)) : choice && color.name === choice[0]
      ? data.media.find(m => m.id === choice[1]) : mediaFor(data, color);
    if (!media) return;
    for (const link of card.querySelectorAll('a[href]')) {
      const url = new URL(link.href, location.origin);
      if (url.pathname === data.url.split('?')[0]) {
        if (data.useFeaturedDefault && !data.featuredVariant) url.searchParams.delete('variant');
        else url.searchParams.set('variant', String(data.useFeaturedDefault ? data.featuredVariant : color.variant));
        link.href = url.pathname + url.search + url.hash;
      }
    }
    const gallery = card.querySelector('.card-gallery');
    const slide = gallery?.querySelector(`[slide-id="${media.id}"]`);
    if (slide) {
      for (const variantSlide of gallery.querySelectorAll('slideshow-slide[variant-image]')) variantSlide.hidden = variantSlide !== slide;
      slide.hidden = false;
      gallery.querySelector('slideshow-component')?.select?.({ id: String(media.id) }, undefined, { animate: false });
    }
    else {
      const image = card.querySelector('img');
      if (image) {
        image.src = imageSource(media.src);
        image.srcset = [240, 400, 700, 900].map(w => `${imageSource(media.src, w)} ${w}w`).join(', ');
      }
    }
    card.dataset.featuredMediaUrl = imageSource(media.src, 500);
    card.dataset.apparelCardColor = color?.name || 'merchant featured image';
    card.addEventListener('change', () => { card.dataset.apparelCustomerSelection = 'true'; }, { once: true });
  }

  function orderGallery(data, ranked, reviewed) {
    // Never assign ambiguous numeric mockups to colors by source position.
    const known = new Map();
    for (const color of ranked) if (color.media) known.set(String(color.media), color.name);
    if (data.id === 10253573980263) known.set('46395276722279', 'Sport Grey');
    for (const media of data.media) {
      if (reviewed[media.id]) {
        const nativeColor = ranked.find(c => key(c.name) === key(reviewed[media.id]));
        if (nativeColor) known.set(String(media.id), nativeColor.name);
      }
      if (reviewed.__unavailable?.includes(String(media.id))) known.set(String(media.id), '__unoffered');
      if (ranked.length === 1) known.set(String(media.id), ranked[0].name);
      if (known.has(String(media.id))) continue;
      const filename = key(base(media.src));
      const matches = ranked.filter(color => (`-${filename}-`).includes(`-${key(color.name)}-`));
      if (matches.length === 1) known.set(String(media.id), matches[0].name);
    }
    const gallery = document.querySelector('main media-gallery');
    if (!gallery) return;
    const missing = data.media.filter(m => !known.has(String(m.id)) && !reviewedNeutral.has(String(m.id)) && !reviewed.__neutral?.includes(String(m.id)));
    gallery.dataset.apparelUnmappedMedia = missing.map(m => m.id).join(',');
    gallery.dataset.apparelGalleryOrderReady = String(missing.length === 0);
    if (missing.length) return;
    const originalSlides = [...gallery.querySelectorAll('slideshow-slide[slide-id]')];
    if (!originalSlides.length) return;
    const ordered = [...data.media].sort((a, b) => {
      const neutral = m => reviewedNeutral.has(String(m.id)) || reviewed.__neutral?.includes(String(m.id));
      if (neutral(a) !== neutral(b)) return neutral(a) ? 1 : -1;
      const ac = ranked.findIndex(c => c.name === known.get(String(a.id)));
      const bc = ranked.findIndex(c => c.name === known.get(String(b.id)));
      const colorRank = (ac < 0 ? ranked.length : ac) - (bc < 0 ? ranked.length : bc);
      if (colorRank) return colorRank;
      const viewRank = m => {
        const color = ranked.find(c => c.name === known.get(String(m.id)));
        if (String(m.id) === String(color?.media)) return 0;
        if (reviewed.__views?.[m.id] != null) return reviewed.__views[m.id];
        const filename = base(m.src).toLowerCase();
        return filename.includes('-front-') ? 0 : filename.includes('-back-') ? 2 : filename.includes('-lifestyle-') ? 3 : 1;
      };
      return viewRank(a) - viewRank(b);
    });
    const indices = new Map(ordered.map((m, i) => [String(m.id), i]));
    const mediaId = node => {
      if (node.hasAttribute('slide-id')) return node.getAttribute('slide-id');
      const idMatch = node.id?.match(/^product-(\d+)-/);
      if (idMatch) return idMatch[1];
      const image = node.querySelector('img');
      if (image) return String(data.media.find(m => base(m.src) === base(image.getAttribute('src')))?.id || '');
      const select = node.getAttribute('on:click')?.match(/^\/select\/(\d+)$/);
      return select ? originalSlides[Number(select[1])]?.getAttribute('slide-id') : '';
    };
    const nodes = [...gallery.querySelectorAll('slideshow-slide[slide-id], [ref="thumbnails[]"], [ref="dots[]"], [ref="media[]"], .dialog-thumbnails-list__thumbnail')];
    const groups = new Map();
    for (const node of nodes) {
      const id = mediaId(node);
      if (!indices.has(id)) continue;
      if (!groups.has(node.parentElement)) groups.set(node.parentElement, []);
      groups.get(node.parentElement).push({ node, id });
    }
    for (const [parent, entries] of groups) {
      const sorted = [...entries].sort((a, b) => indices.get(a.id) - indices.get(b.id));
      if (sorted.some((entry, i) => entry.node !== entries[i].node)) {
        const anchor = document.createComment('native apparel media order');
        parent.insertBefore(anchor, entries[0].node);
        for (const entry of sorted) parent.insertBefore(entry.node, anchor);
        anchor.remove();
      }
      for (const { node, id } of sorted) {
        const index = indices.get(id);
        for (const bound of [node, ...node.querySelectorAll('[on\\:click], [on\\:pointerenter]')]) {
          for (const attr of ['on:click', 'on:pointerenter']) {
            const value = bound.getAttribute(attr);
            if (value && /\/(select|open|handleThumbnailClick|handleThumbnailPointerEnter)\/\d+$/.test(value)) {
              bound.setAttribute(attr, value.replace(/\d+$/, String(index)));
            }
          }
        }
        const label = node.getAttribute('aria-label');
        if (label && /^Slide \d+ of \d+$/.test(label)) node.setAttribute('aria-label', `Slide ${index + 1} of ${ordered.length}`);
        if (node.tagName === 'SLIDESHOW-SLIDE') node.style.setProperty('--slideshow-timeline', `--slide-${index}`);
      }
    }
    const selected = document.querySelector('main variant-picker [data-color-value]:checked')?.value;
    const color = ranked.find(c => c.name === selected);
    if (color?.media) requestAnimationFrame(() => gallery.slideshow?.select?.({ id: String(color.media) }, undefined, { animate: false }));
    gallery.dataset.apparelGalleryOrder = 'light-to-dark';
  }

  async function process(node) {
    if (processed.has(node)) return;
    processed.add(node);
    try {
      const data = JSON.parse(node.textContent);
      const { ranked, reviewed } = await resolve(data);
      if (!node.isConnected) return;
      if (node.dataset.apparelMerchandising === 'product') {
        orderGallery(data, ranked, reviewed);
        document.addEventListener(StandardEvents.productSelect, event => {
          if (event.target.closest('main variant-picker')) event.promise.then(() => requestAnimationFrame(() => orderGallery(data, ranked, reviewed))).catch(() => {});
        });
        const url = new URL(location.href);
        if (!productInteraction && !url.searchParams.has('variant') && !url.searchParams.has('option_values')) {
          const color = data.useFeaturedDefault ? ranked.find(c => String(c.variant) === String(data.featuredVariant)) : ranked.find(c => c.available);
          if (color?.variant) {
            url.searchParams.set('variant', String(color.variant));
            location.replace(url.href);
          }
        }
      } else updateCard(node, data, ranked);
      node.dataset.apparelStatus = 'resolved';
    } catch (error) {
      node.dataset.apparelStatus = 'held';
      console.warn('Apparel merchandising:', error.message);
    }
  }
  function scan() {
    if (!window.LaurelColorOrder) return;
    document.querySelectorAll('script[data-apparel-merchandising]').forEach(process);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  let queued = false;
  new MutationObserver(records => {
    if (queued || !records.some(r => [...r.addedNodes].some(n => n.nodeType === 1))) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; scan(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
